(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.dialogBounce = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var MAX_OFFSET = 60;
  var BOUNCE_EFFECT = Math.E;
  var CLOSE_THRESHOLD = 80;

  exports.default = {
    data: function data() {
      return {
        touchstartY: 0,
        touchmoveY: 0,
        dialogStyle: '',
        dialogDom: null
      };
    },

    methods: {
      calculateOffset: function calculateOffset() {
        if (this.touchmoveY < 0) {
          return this.touchmoveY / 20 - MAX_OFFSET * (1 - 1 / Math.pow(BOUNCE_EFFECT, -this.touchmoveY / 100)) + 'px';
        } else {
          if (this.$refs.bounceDialog && this.$refs.bounceDialog.slideDownOut) {
            return this.touchmoveY + 'px';
          } else {
            return this.touchmoveY / 20 - MAX_OFFSET * (1 - 1 / Math.pow(BOUNCE_EFFECT, -this.touchmoveY / 400)) + 'px';
          }
        }
      },
      handleTouchstart: function handleTouchstart(eve) {
        if (!this.dialogDom) {
          this.dialogDom = this.$refs.bounceDialog.$el.querySelector('.nx-popup-box');
        }
        this.dialogStyle = this.dialogDom.style;
        this.dialogDom.style.transform = 'translateY(0)';
        this.dialogDom.style.transition = 'none';
        this.touchstartY = eve.touches[0].clientY;
      },
      handleTouchmove: function handleTouchmove(eve) {
        this.touchmoveY = eve.touches[0].clientY - this.touchstartY;
        this.dialogDom.style.transform = 'translateY(' + this.calculateOffset() + ')';
      },
      handleTouchend: function handleTouchend(close) {
        var _this = this;

        this.dialogDom.style.transition = 'transform 0.2s ease-out';
        this.$nextTick(function () {
          if (_this.touchmoveY < CLOSE_THRESHOLD) {
            _this.dialogDom.style.transform = 'translateY(0)';
            _this.dialogDom.removeAttribute('style');
          } else {
            _this.dialogDom.removeAttribute('style');
            if (_this.$refs.bounceDialog && _this.$refs.bounceDialog.slideDownOut) {
              _this.$nextTick(function () {
                typeof close === 'function' && close();
              });
            }
          }
        });
      }
    }
  };
});